import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'sonner';

const PagamentoAluguel = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { state } = useLocation();
  const [metodo, setMetodo] = useState<'pix' | 'cartao' | null>(null);
  const [pago, setPago] = useState(false);

  useEffect(() => {
    const video = document.getElementById('bgVideo') as HTMLVideoElement | null;
    if (window.innerWidth < 768 && video) {
      video.pause();
      video.style.display = 'none';
    }
  }, []);

  useEffect(() => {
    if (!state || !state.videoTitle || !state.videoPrice) {
      navigate('/');
    }
  }, [state, navigate]);

  const handlePagamento = () => {
  const existing = JSON.parse(localStorage.getItem('alugados') || '{}');
  const expiresAt = new Date(Date.now() + 48 * 60 * 60 * 1000); // 48 horas
  const updated = {
    ...existing,
    [id!]: {
      expiresAt: expiresAt.toISOString(),
    },
  };
  localStorage.setItem('alugados', JSON.stringify(updated));

  toast.success("Pagamento confirmado! Você tem 48h para assistir.");
  setPago(true);
  setTimeout(() => {
    navigate('/');
   }, 2000);
  };


  return (
    <>
      <div className="signup-container h-screen w-full flex justify-center items-center relative overflow-hidden pt-[80px] sm:pt-[60px]">
        <div className="video-container absolute top-0 left-0 w-full h-full z-[-1] overflow-hidden">
          <video autoPlay muted loop playsInline id="bgVideo" className="min-w-full min-h-full object-cover opacity-50">
            <source src="/video/intro.mp4" type="video/mp4" />
          </video>
        </div>

        <nav className="navbar absolute top-2 left-4 z-10">
          <img src="/img/logo.png" alt="RusticoPlay Logo" className="h-[50px] sm:h-[70px] w-auto max-w-[160px] sm:max-w-[200px]" />
        </nav>

        <div className="signup-box bg-[rgba(0,0,0,0.3)] p-10 rounded-lg w-full max-w-[800px] text-center z-[1] border border-rustico-brown overflow-y-auto max-h-[95vh]">
          <h2 className="mb-5 text-[2rem] font-bold text-white">Pagamento do Aluguel</h2>
          <p className="mb-2 text-lg text-white">🎬 <strong>Vídeo:</strong> {state?.videoTitle}</p>
          <p className="mb-6 text-lg text-white">💰 <strong>Valor:</strong> R$ {state?.videoPrice},00</p>

          <div className="plans mt-8">
            <h3 className="text-[1.5rem] mb-5 text-white">Escolha a forma de pagamento:</h3>
            <div className="flex gap-5 justify-center flex-wrap">
              <button
                type="button"
                onClick={() => setMetodo('pix')}
                className={`p-4 bg-white/10 text-white rounded-lg w-[150px] transition hover:bg-white/20 ${metodo === 'pix' ? 'ring-2 ring-green-500' : ''}`}
              >
                Pix
              </button>
              <button
                type="button"
                onClick={() => setMetodo('cartao')}
                className={`p-4 bg-white/10 text-white rounded-lg w-[150px] transition hover:bg-white/20 ${metodo === 'cartao' ? 'ring-2 ring-blue-500' : ''}`}
              >
                Cartão de Crédito
              </button>
            </div>
          </div>

          {metodo && !pago && (
            <button
              onClick={handlePagamento}
              className="w-full mt-8 p-[12px] bg-white/20 text-white font-bold rounded-md hover:bg-white/30 transition-colors"
            >
              Confirmar Pagamento
            </button>
          )}

          {pago && <p className="mt-6 text-green-400 font-semibold">✅ Pagamento confirmado! Redirecionando...</p>}
        </div>
      </div>
    </>
  );
};

export default PagamentoAluguel;
